import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import EditableTextField, {TextFieldType} from 'ui-library/inputs/EditableTextField';
import copyToClipboard from 'util/clipboard/copyToClipboard';

export interface PublicKeySectionProps {
  value: string | null;
  onChangePublicKey: (newPublicKey: string) => void;
}

interface ClipboardButtonProps {
  getValue: () => string;
}

export function ClipboardButton(props: ClipboardButtonProps): JSX.Element | null {
  return (
    <Tooltip container="body" placement={TooltipPlacement.TOP} title="Copy public key">
      <Button
        buttonStyle={ButtonStyle.CIRCLE_ICON}
        size={ButtonSize.MINI}
        className={css(styles.upperRight)}
        icon="copy"
        onClick={() =>
          copyToClipboard(props.getValue(), {
            showToastOnSuccess: true,
            toastText: 'Copied public key to clipboard.',
          })
        }
      />
    </Tooltip>
  );
}

export default function PublicKeySection(props: PublicKeySectionProps): JSX.Element | null {
  function getValue(): string {
    return props.value ?? '';
  }

  return (
    <div>
      <h3 className={classNames('header--header3')}>Public Key</h3>
      <div className={css(styles.sectionDescription)}>
        This key is used to encrypt values stored securely in app configs.
      </div>
      <div className={css(styles.textParent)}>
        <EditableTextField
          inputClassName={css(styles.editableTextFieldClass)}
          emptyValueAllowed={true}
          placeholder="Public Key for encrypting secure_text app config items"
          value={props.value ?? ''}
          requestChange={props.onChangePublicKey}
          type={TextFieldType.TEXTAREA}
        />
        {props.value != null && <ClipboardButton getValue={getValue} />}
      </div>
    </div>
  );
}

const LARGE_TEXTAREA_HEIGHT = 180;
const styles = StyleSheet.create({
  sectionDescription: {
    marginBottom: '15px',
  },
  textParent: {
    position: 'relative',
  },
  upperRight: {
    position: 'absolute',
    right: '1em',
    top: '1em',
  },
  editableTextFieldClass: {
    minHeight: LARGE_TEXTAREA_HEIGHT,
    resize: 'none',
  },
});
